<template>
  <div class="p-grid">
    <div class="p-col-12">
      <Panel header="Gerenciamento de Locais" style="height: 100%">
        <Toolbar class="p-mb-4">
          <template #start>
            <Button
              label="Novo"
              icon="pi pi-plus"
              class="mr-2"
              @click="showCreate()"
            />
          </template>
          <template #end>
            <div
              class="
                table-header
                p-d-flex p-flex-column p-flex-md-row p-jc-md-between
              "
            >
              <span class="p-input-icon-left">
                <i class="pi pi-search" />
                <InputText
                  v-model="filters['global'].value"
                  placeholder="Buscar..."
                />
              </span>
            </div>
          </template>
        </Toolbar>
        <DataTable
          ref="dt"
          dataKey="id"
          class="p-datatable-sm"
          :value="locals"
          :paginator="true"
          :rows="10"
          :rowsPerPageOptions="[10, 20, 50]"
          :filters="filters"
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          currentPageReportTemplate="Exibindo de {first} a {last} no total de {totalRecords} locais."
          :loading="loading"
        >
          <template #empty>
            <div class="p-text-center">Nenhum resultado encontrado...</div>
          </template>
          <Column header="Nome" field="name" :sortable="true">
            <template #body="slotProps">
              {{ slotProps.data.name }}
            </template>
          </Column>
          <Column header="Lotação Maxíma" field="cap_max" ref="capMax" :sortable="true">
            <template #body="slotProps">
              {{ slotProps.data.capMax }}
            </template>
          </Column>
          <Column header="Lotação Minima" field="capMin" :sortable="true">
            <template #body="slotProps">
              {{ slotProps.data.capMin }}
            </template>
          </Column>
          <Column header="Status" field="status" :sortable="true">
            <template #body="slotProps">
              <span
                :class="'badge status-' + slotProps.data.status"
                @click="changeStatus(slotProps.data)"
                v-tooltip.top="'Clique para alterar Status'"
                style="cursor: pointer"
                >{{ $Util.formatAtivo(slotProps.data.status) }}</span
              >
            </template>
          </Column>
          <Column header="Ações">
            <template #body="slotProps">
              <Button
                icon="pi pi-pencil"
                class="p-button-rounded p-button-success mr-2"
                @click="showUpdate(slotProps.data)"
                v-tooltip.top="'CLIQUE PARA EDITAR'"
              />
              <Button
                icon="pi pi-trash"
                class="p-button-rounded p-button-warning"
                @click="showRemove(slotProps.data)"
                v-tooltip.top="'CLIQUE PARA EXCLUIR'"
              />
            </template>
          </Column>
        </DataTable>
      </Panel>
    </div>
    <ConfirmDialog></ConfirmDialog>
  </div>

  <!--MODAL CADASTRAR-->
  <dialog-form :localSelected="obj" @findAll="findAll" />
  <!--FIM MODAL CADASTRAR-->
</template>

<script>
import { FilterMatchMode } from "primevue/api";

//models
import Local from "../../../src/models/internal/local";

//Services
import LocalService from "../../../src/service/internal/local/local_service.js";

//components
import DialogForm from "./components/dialog-form.vue";

export default {
  components: {
    DialogForm,
  },
  data() {
    return {
      loading: false,
      locals: [],
      obj: new Local(),
      permissoes: [],
      filters: {},
      filtersPermissions: {},
      service: new LocalService(),
    };
  },
  created() {
    this.initFilters();
  },
  mounted() {
    this.findAll();
  },
  methods: {
    changeStatus(data) {
      this.service
        .changeStatus(data.id)
        .then((data) => {
        if (data.status === 200) {
            this.$msgSuccess(data);
            this.hideDialog();
            this.findAll();
          }
         })
         .catch((error) => {
          this.$msgErro(error);
        });
    },
    showCreate() {
      this.obj = new Local();
      this.$store.state.views.local.dialogForm = true;
    },
    showUpdate(local) {
      this.obj = local;
      this.$store.state.views.local.dialogForm= true;
    },
    showRemove(local) {
      this.$confirm.require({
        message: "Deseja Excluir esse registro?",
        header: "Deseja deletar?",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Sim",
        rejectLabel: "Não",
        accept: () => {
          this.service
            .delete(local.id)
            .then((data) => {
              this.$msgSuccess(data);
              this.findAll();
            })
            .catch((error) => {
              this.$msgErro(error);
            });
        },
      });
    },
    hideDialog() {
      this.local = new Local();
      this.submitted = false;
      this.$emit("findAll");
      this.visibleDialog = false;
    },
    findAll() {
      this.loading = true;
      this.service.findAll().then((data) => {
        this.locals = data;
        this.loading = false;
      });
    },
    initFilters() {
      this.filters = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      };
      this.filtersPermissions = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("../../App.scss");
</style>
